import "./notification.css";
import Topbar from "../../components/topbar/Topbar";
import axiosInstance from '../../config';
import { useState, useEffect, useContext } from "react";
import { useParams } from "react-router";
import { useNavigate } from "react-router-dom";
import { Notifications } from "@mui/icons-material";
import SocialContext from '../../context/SocialContext';
import Bottom from "../../components/Bottom/Bottom";
import Alertjs from "../../components/alert/Alert";
import Progress from '../../components/Progress/Progress'
import NotificationBox from '../../components/notificationBox/NotificationBox'


export default function Profile() {
  const navigate = useNavigate();
  const { setunreadnotification,setuser: setcurrentuser, user: currentuser, showalert, scrolltoTopfun, isfetching } = useContext(SocialContext);
  const PF = "https://socialshub.netlify.app/images/";

  const userID = useParams().userID;  // store username from url

  const [allnotifications, setallnotifications] = useState([])    // this is empty object // store profil's user details
  const [loading, setloading] = useState(false)

  // for fetch user's profile 
  useEffect(() => {
    const fetchUser = async () => {
      try {
        setloading(true);
        const response = await axiosInstance.get(`/api/notification/allnotification/${userID}`);
        setallnotifications(response.data);
        setloading(false);
        // mark all notification as read
        await axiosInstance.put('/api/notification/markallread/'+userID);
        setunreadnotification(0);
      } catch (error) {
        console.log("errot inside profile ", error);
        navigate('*');
      }
    }
    fetchUser();
  }, [userID]);

  useEffect(()=>{
    scrolltoTopfun();
  })

  return (
    <>
      <Topbar />

      {showalert ? <div style={{ 'height': '45px', 'position': 'sticky', 'top': '50px', 'zIndex': '2' }}>
        <Alertjs allertmessage={"Plese write something and try again..."} />
      </div> : ""}

      <div className="notificationPage">
        <div className="notiicon">
          <Notifications style={{ 'fontSize': '40px', 'marginRight': '5px' }} />
          <h1>Your Notifications</h1>
        </div>
        {loading ? <Progress /> :
          <div className="notifications">
            { allnotifications.length>0 ? allnotifications.map((item) => (
              <NotificationBox key={item._id} notification={item}/>
            )):<h4 style={{'color':'blue','fontSize':'23px'}}>No any notification</h4>}
          </div>
        }
      </div>
      <div className="copyright" style={{ 'backgroundColor': '#dadada' }}>
        <p style={{ 'textAlign': 'center', opacity: '0.6' }}>Copyright ©2022-Alok.info | All rights reserved</p>
      </div>
      <Bottom />
    </>
  );
}

